(function(){
    angular
        .module('maApp.validation')
        .factory('DateCompareValidator', DateCompareValidator);

    DateCompareValidator.$inject = ['$log', '$interpolate'];

    function DateCompareValidator($log, $interpolate){
        return {
            'create':create
        };

        /**
         * create
         *
         * creates a validator function that can compare dates with a provided compare function
         *
         * @param scope
         * @param attrs
         * @param directiveName Used to pull the related element attribute (ex. pbDateAfterOrEqualTo for the pb-date-after-or-equal-to directive)
         * @param compareFn Compare function that is called as compareFn(inputDate, dateToCompareTo). Dates are passed in as momentjs objects
         * @returns {Function} Function that can be added to control's $validators
         */
        function create(scope, attrs, directiveName, compareFn){
            return function (modelValue) {
                try{
                    var compareDate = scope.$eval(attrs[directiveName]);
                    if(!compareDate){
                        return true;    //even though this isn't valid, we're saying that this validator is should be ignored because we don't have a date to compare to. without this, showing the correct error is difficult unless you are using a custom controller for a start-end-date-picker
                    }
                } catch(e){
                    throw $log.error($interpolate('Could not eval {{d}}')({d:directiveName}), attrs[directiveName]);
                }

                var modelDate = Date.create(modelValue);
                compareDate = Date.create(compareDate);
                return modelDate.isValid() && compareDate.isValid() && compareFn(modelDate, compareDate);

            }
        }
    }
})();